import { avatarAnatomy as parts } from '@chakra-ui/anatomy';
import type { PartsStyleObject } from '@chakra-ui/styled-system';

const baseStyle: PartsStyleObject = {
  label: {
    width: '100%',
  },
};

export default {
  parts: parts.keys,
  baseStyle,
};
